import React from 'react'

export const PresetConfigLoader = () => {
  return (
    <div className='d-flex align-items-center justify-content-center p-2'>
      <div
        className='skeleton w-100 text-center mb-3'
        style={{
          height: '5rem',
          verticalAlign: 'middle',
          lineHeight: '5rem',
        }}
      ></div>
    </div>
  )
}
